export type PendingDocumentSummary = {
  totalPending:number;readyForReview:number;needsAttention:number;processing:number;unlinked:number;
  /** Filed Unverified with details still to confirm: filed, so not part of totalPending. */
  filedWithDetails?:number;
  evaluatedScope:{kind:'portfolio'}|{kind:'building';id:string};
};

export function validatedPendingSummary(value:unknown,building?:string):PendingDocumentSummary {
  if(!value||typeof value!=='object')throw new Error('Document attention is unavailable.');
  const result=value as PendingDocumentSummary;
  const scope=result.evaluatedScope;
  if(building?scope?.kind!=='building'||scope.id!==building:scope?.kind!=='portfolio')throw new Error('Document attention did not confirm the current scope.');
  const counts=[result.totalPending,result.readyForReview,result.needsAttention,result.processing,result.unlinked,result.filedWithDetails??0];
  if(counts.some(count=>!Number.isSafeInteger(count)||count<0)||result.readyForReview+result.needsAttention+result.processing!==result.totalPending||result.unlinked>result.totalPending||Boolean(building)&&result.unlinked!==0)throw new Error('Document attention returned inconsistent counts.');
  return result;
}
